'use client';

import type { FC } from 'react';
import { buttonVariants, Title } from '@paypoteam/ui-components';
import Link from 'next/link';

import { cn } from '@/lib/utils';

type LinksListItem = {
    text: string;
    href: string;
    buttonText: string;
};

export interface LinksListProps {
    linksList: LinksListItem[];
}

const LinksList: FC<LinksListProps> = ({ linksList }) => (
    <ul className="w-auto">
        {linksList.map((link, i) => (
            <li
                key={`link-list-item-${i}`}
                className="flex flex-wrap items-center justify-between border-b py-6 last:border-b-0 last:pb-0 sm:flex-nowrap"
            >
                <Title
                    size="m"
                    className="mb-3 w-auto sm:mb-0"
                >
                    {link.text}
                </Title>

                <Link
                    href={link.href}
                    target="_blank"
                    data-test-id={`integration-download-link-button-${i}`}
                    className={cn(
                        buttonVariants({ variant: 'outline', size: 's' }),
                        'whitespace-nowrap sm:ml-4',
                    )}
                >
                    {link.buttonText}
                </Link>
            </li>
        ))}
    </ul>
);

export default LinksList;
